export const SidebarId = {
  AppModules: 'app-modules',
  ProfileMenu: 'profile-menu',
  News: 'news',
  Navigation: 'nav',
};
